<template>
  <div id="Payment">
    <div class="topBg"></div>
    <b-container fluid class="paymentMain">
      <b-row>
        <b-col>
          <h1>Payment Options</h1>
          <div class="line"></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6" md="12">
					<!-- <h2>Renewal Deadline - Firday, September 26, 2018</h2>
          <p>Thank you for being a Rays Season Member! Renew your seats now for the 2019 and 2020 seasons via the Double Play opportunity and receive the lowest season ticket price, added benefits and the choice of one exclusive gift. Also, spread out your payments interest-free via the 20-month Autopay option. If you have a Half Season or 22 Game Plan, upgrade today to the Full Season Plan and receive access to the best Double Play gift options.</p> -->
					<div class="paymentOption">
						<div class="icon">
							<img svg-inline :src="require('@/assets/icons/payment-options-2.svg')" />
						</div>
						<div class="plan">
							<h3>Pay In Full</h3>
							<p>Ensure access to your exclusive presale in March of 2021.</p>
						</div>
					</div>
					<div class="paymentOption">
						<div class="icon">
							<img svg-inline :src="require('@/assets/icons/payment-options-1.svg')" />
						</div>
						<div class="plan">
							<h3>Payment Plan</h3>
							<p>
								Spread out your Season Membership payments with two (2) installments
								interest-free! Select this option to authorize the Rays to automatically
								charge your credit card on a designated date each month (see enclosed
								invoice or your online account for specific payment schedule), for 2 months,
								from your initial installment through May of 2021. Each payment will
								represent 50% of the cost of your membership. Please note your first
								payment will be deducted at the time of submission.
							</p>
						</div>
					</div>
					
        </b-col>
        <b-col lg="6" md="12" class="additionalGuidelines">
          <h3>Additional Guidelines</h3>
					<ul>
						<li>We continue to work with Major League Baseball and public health officials to determine when and how to safely welcome fans back to Tropicana Field. After purchasing your Season Membership, you will be notified via email when games are available for selection.</li>
						<li>Please note, if you select an interest-free payment plan, the credit on your account will become available once you have paid 50% of your account balance.</li>
						<li>After renewing your Season Membership, please allow at least two business days for credit to appear on your account.</li>
					</ul>
        </b-col>
      </b-row>
			<b-row>
				<div class="renewBtn">
					<a target="_blank" href="http://www.raysbaseball.com/policiesandprocedures">Policies and Procedures</a>
				</div>
			</b-row>
     
   
    </b-container>
    <div class="bottomBg"></div>
  </div>
</template>

<script>
export default {
  name: "Gifts"
}
</script>

<style lang="scss" scoped>
  #Payment {
    .topBg {
      background-image: url("~@/assets/images/bg-blue-3.png");
      background-size: cover;
      background-position: top;
      background-repeat: no-repeat;
      height: 300px;
    }
    .paymentMain {
      background-color: #002d62;
      padding: 0 7%;
      h1 {
        font-family: 'UniversLTStd-UltraCn';
        color: #fff;
        font-size: 50px;
        text-transform: uppercase;
				@media only screen and (max-width: $sm) {
					font-size: 42px;
				}
      }
      h2 {
        font-family: 'UniversLTStd-Bold';
        color: $light-blue;
        font-size: 22px;
        margin: 0 0 15px 0;
      }
      .line{
        background-color: $yellow;
        width: 190px;
        height: 3px;
        margin: 10px 0 40px 0;
      }
      p {
        font-family: 'UniversLTStd-Light';
        font-size: 16px;
        color: #fff;
				text-align: justify;
				text-justify: inter-word;
			}
			.paymentOption {
				display: flex;
				margin: 25px 0;
				.icon {
					margin-right: 20px;
					img {
						width: 120px;
						background-color: $yellow;
						border-radius: 50%;
						padding: 7px;
						@media only screen and (max-width: $sm) {
							width: 60px;
							position: relative;
							top: 20px;
						}
					}
				}
				.plan {
					width: 100%;
					h3 {
						font-family: 'UniversLTStd-Bold';
						color: $light-blue;
						font-size: 16px;
						margin-top: 35px;
					}
				}
			}
			ul {
				margin: 0;
				padding: 0;
				list-style: none;
				li {
					font-family: 'UniversLTStd-Light';
					color: #fff;
					font-size: 16px;
					padding: 0 0 0 45px;
					margin-bottom: 15px;
					text-align: justify;
					text-justify: inter-word;
					&::before {
						position: relative;
						right: 20px;
						content: "\2022";
						color: $yellow;
						font-weight: bold;
						display: inline-block; 
						width: 1em;
						margin-left: -1em;
					}
				}
			}
			.additionalGuidelines {
				margin-top: 58px;
				h3 {
					font-family: 'UniversLTStd-Bold';
					color: $light-blue;
					font-size: 16px;
				}
				@media only screen and (max-width: $lg) {
					margin-top: 25px;
				}
			}
			.renewBtn {
				margin: 30px auto 0 auto;
				a {
					font-family: 'UniversLTStd-Bold';
					font-size: 16px;
					color: #000;
					background-color: $yellow;
					border-radius: 25px;
					padding: 15px 40px;
					text-transform: uppercase;
					&:hover {
						text-decoration: none;
					}
				}
			}
    }
    .bottomBg {
      background-image: url("~@/assets/images/bg-blue-4.png");
      background-size: cover;
      background-position: bottom;
      background-repeat: no-repeat;
      height: 300px;
    }
  }
</style>